import {ChangeDetectionStrategy, Component} from '@angular/core';
import {RequestStatusEnum} from '@dto/requests/request-status.enum';
import {RequestListComponent} from '../request-list/request-list.component';

@Component({
    selector: 'app-in-review-requests',
    templateUrl: './in-review-requests.component.html',
    changeDetection: ChangeDetectionStrategy.OnPush,
    imports: [RequestListComponent]
})
export class InReviewRequestsComponent {
  requestStatus = RequestStatusEnum.InReview;
  noRequestsMessage = 'No requests in review';
}
